import React from "react";
import FromInput from "./FromInput";

const InputSection = () => {

  return (
    <div className="mt-[160px] mx-4 md:mt-[160px] relative">
      <div className="bg-white rounded-md max-w-6xl w-full mx-auto">
        <FromInput />
      </div>
    </div>
  );
};

export default InputSection;
